const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-lines', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartlines-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {

				var dim1Values = [];
				for (let i = 0; i < this.chartData.Values.length; i++) {
					if (dim1Values.indexOf(this.chartData.Values[i].TagCode + ':' + this.chartData.Values[i].Dimension1) == -1) {
						dim1Values.push(this.chartData.Values[i].TagCode + ':' + this.chartData.Values[i].Dimension1);
					}
				}
				var colors = window.getChartColors(dim1Values.length);
				const categories = this.chartData.Dimension2.map(dim2 => { return dim2.Value });
				const valuedata = [];
				let max = 0;
				dim1Values.forEach((dim1, ix) => {

					const val = dim1.split(':');
					const dim = this.chartData.Dimension1.find(el => el.TagCode == val[0]);
					const dim1values = this.chartData.Values.filter(el => { return el.TagCode == val[0] && el.Dimension1 == val[1]; }).sort((a, b) => this.chartData.Dimension2.findIndex(d2 => d2.Value == a.Dimension2) - this.chartData.Dimension2.findIndex(d2 => d2.Value == b.Dimension2));
					const values = dim1values.map((v) => { return v.Fact1 || v.Number });
					valuedata.push({
						no: ix + 1,
						name: dim.TagName + ' ' + val[1],
						data: values,
						color: colors[ix]
					})
					const curmax = values.reduce((acc, curval) => {
						if (acc < curval) return curval;
						return acc;
					})
					max = max < curmax ? curmax : max;

				});
				//vuelog('new chardata', max, valuedata);
				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'line'
					},
					xAxis: {
						title: {
							text: null,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						categories: categories,
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 0,
					},
					yAxis: {
						max: max,
						title: {
							text: this.chartData.Kpi[0].KPIName,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						tickColor: globalColors.primary.hue1,
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 1,
						showFirstLabel: false
					},
					legend: {
						enabled: true,
						layout: 'horizontal',
						align: 'right',
						verticalAlign: 'bottom',
						floating: false,
						borderWidth: 1,
						backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
						shadow: true
					},
					series: valuedata
				}));
				this.$emit('chartReady', this.chart);
			}
		}
	})
})();
